"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IEventSettings.js.map